import React from 'react';

interface LoadingOverlayProps {
  message?: string;
  isVisible: boolean;
  zIndex?: number;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  message = 'Loading...',
  isVisible,
  zIndex = 1000
}) => {
  if (!isVisible) return null;
  
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50"
      style={{ zIndex }}
    >
      <div className="bg-white rounded-lg p-8 shadow-lg max-w-md text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-lg font-semibold text-gray-800">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay; 